import { StoreModule } from '@ngrx/store';
import { rootReducer } from 'ChartApp/ts/apps/scatter-plot/state/scatter-plot.reducer';
import { ScatterPlotPageModule } from 'ChartApp/ts/apps/scatter-plot/app.module';
import { BaseSecurityPageModule } from 'SecuritiesApp/ts/apps/base-security-page/app.module';
import { TopBarNavComponent } from 'Angular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { SideMenuComponent } from 'Angular/features/components/side-menu/side-menu.component';
import { ScatterPlotPageComponent } from 'ChartApp/ts/apps/scatter-plot/components/scatter-plot-page/scatter-plot-page.component';
import { SecurityHeaderControlComponent } from 'SecuritiesApp/ts/features/security-header-control/security-header-control.component';
import { getLogger } from 'Angular/state/logger';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
export class MutualFundsScatterPlotAppModule {
}
MutualFundsScatterPlotAppModule.ɵfac = function MutualFundsScatterPlotAppModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MutualFundsScatterPlotAppModule)(); };
MutualFundsScatterPlotAppModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: MutualFundsScatterPlotAppModule, bootstrap: [ScatterPlotPageComponent, TopBarNavComponent, SideMenuComponent, SecurityHeaderControlComponent] });
MutualFundsScatterPlotAppModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [
        // ScatterPlotPageModule must be imported before BaseSecurityPageModule because
        // ScatterPlotPageModule imports HttpClientJsonpModule module, and
        // HttpClientJsonpModule must be imported before BaseSecurityPageModule
        // to prevent X-CSRFToken header from being included in
        // jsonp requests https://github.com/angular/angular/issues/47312
        ScatterPlotPageModule,
        BaseSecurityPageModule,
        StoreModule.forRoot({ reducers: rootReducer }, { metaReducers: getLogger() })] });
